// Import Components from react library
import React from 'react';
import { useEffect, useState } from "react";


// CSS file for this page
import '../styles/Comparison.css';


// Components

// Manage the creation of Bar Chart
import ComparisonChart from '../components/ComparisonChart'

// Create the header of the website (with menu selection and the title)
import Header from '../components/Header';

// Create a search box for the countries
import ComparisonSearchBox from '../components/ComparisonSearchBox';

// Create a slider for selecting a year
import Slider from '../components/Slider';

function Comparison() {

    // Set the minimum/maximum value for the year slider
    const min='1990';
    const max='2021';


    // Setting up state variables using useState hook

    // To store the First selected country
    const [selectedCountry1, setSelectedCountry1] = useState("");

    // To store the Second selected country
    const [selectedCountry2, setSelectedCountry2] = useState("");

    // To store the selected year
    const [selectedYear, setSelectedYear] = useState(min);

    const [value1, setValue1] = useState(0);
    const [value2, setValue2] = useState(0);


    return (
        <>
            {/* Header of the website */}
            <Header />

            {/* Main container for the page */}
            <div className='comparison-container'>

                <div className="filter-wrapper">

                    {/* Wrapper for the searchboxes */}
                    <div className='search-box-wrapper'>

                        {/* Search boxes for searching countries */}
                        <ComparisonSearchBox
                            id='1'
                            // Set selectedCountry1 from child component
                            selectCountry={setSelectedCountry1}
                        />

                        <ComparisonSearchBox
                            id='2'
                            // Set selectedCountry2 from child component
                            selectCountry={setSelectedCountry2}
                        />

                    </div>


                    {/* Slider for filtering the year */}
                    <Slider
                        id="comparison-year-selector"
                        min={min}
                        max={max}
                        year={selectedYear}
                        // Set selectedYear from child component
                        selectYear={setSelectedYear}
                    />

                </div>


                {/* Wrapper for the data chart */}
                <div className='comparison-chart-wrapper'>

                    {/* Show the rate for the selected year for each country */}
                    <ComparisonText
                        country1={selectedCountry1}
                        country2={selectedCountry2}
                        value1={value1}
                        value2={value2}
                    />


                    {/* Show the chart with data from the two countries */}
                    <ComparisonChart
                        country1={selectedCountry1}
                        country2={selectedCountry2}
                        setValue1={setValue1}
                        setValue2={setValue2}
                        year={selectedYear}
                    />

                </div>

            </div>

        </>
    );
}

// Component used for showing the rate of each country on a selected year
function ComparisonText({country1, country2, value1, value2}) {

    return (
        <div className="comparison-text">
            <div id="country1">
                {country1 ? country1 : "country 1"}
                <div id="value1">{value1}%</div>
            </div>

            <div id="country2">
                {country2 ? country2 : "country 2"}
                <div id="value2">{value2}%</div>
            </div>
        </div>
    );
}

export default Comparison
